<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'SMTP_SETTINGS' }
  ]"
></breadcrumbs>
<page-header title="SMTP_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SMTP_HOST">{{
        'SMTP_HOST' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="SMTP_HOST"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SMTP_HOST'])"
          [ngClass]="{ 'is-danger': hasError('SMTP_HOST') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SMTP_HOST')">
        {{ getError('SMTP_HOST') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SMTP_PORT">{{
        'SMTP_PORT' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="SMTP_PORT"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SMTP_PORT'])"
          [ngClass]="{ 'is-danger': hasError('SMTP_PORT') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SMTP_PORT')">
        {{ getError('SMTP_PORT') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SMTP_USERNAME">{{
        'SMTP_USERNAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="SMTP_USERNAME"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SMTP_USERNAME'])"
          [ngClass]="{ 'is-danger': hasError('SMTP_USERNAME') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SMTP_USERNAME')">
        {{ getError('SMTP_USERNAME') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SMTP_PASSWORD">{{
        'SMTP_PASSWORD' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="SMTP_PASSWORD"
          type="password"
          (input)="handleFieldChange($event)"
          [value]="getField(['SMTP_PASSWORD'])"
          [ngClass]="{ 'is-danger': hasError('SMTP_PASSWORD') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SMTP_PASSWORD')">
        {{ getError('SMTP_PASSWORD') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SMTP_FROMEMAIL">{{
        'SMTP_FROMEMAIL' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="SMTP_FROM_EMAIL"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['SMTP_FROM_EMAIL'])"
          [ngClass]="{ 'is-danger': hasError('SMTP_FROM_EMAIL') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SMTP_FROM_EMAIL')">
        {{ getError('SMTP_FROM_EMAIL') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="SMTP_REQUIRES_AUTH">{{
        'SMTP_REQUIRES_AUTH' | translate
      }}</label>
      <div class="control">
        <chip
          [checked]="getField(['SMTP_REQUIRES_AUTH'])"
          (onChange)="checkboxChange($event, 'SMTP_REQUIRES_AUTH')"
          [value]="!getField(['SMTP_REQUIRES_AUTH'])"
        >
          <span
            [translationEditableDirective]="
              getField(['SMTP_REQUIRES_AUTH']) ? 'ENABLED' : 'DISABLED'
            "
          >
            {{
              (getField(['SMTP_REQUIRES_AUTH']) ? 'ENABLED' : 'DISABLED')
                | translate
            }}
          </span>
        </chip>
      </div>
      <p class="help is-danger" *ngIf="hasError('smtpRequiresAuth')">
        {{ getError('smtpRequiresAuth') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SAVE"
      (click)="onSubmit($event)"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
